export default __webpack_public_path__ + "images/ba494177da1f2a3aae34fe0158e1f857.png";